import { Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";
import React from "react";
import BOIndividualsList from "./BOIndividualsList";

const TrustAdditionalDetailsIndividuals = () => {
  return (
    <Grid size={{ xs: 12 }}>
      <Card>
        <CardHeader title="Individual Details" />
        <CardContent>
          <Typography variant="body1" gutterBottom>
            Please provide the details of each of the Individuals that are
            Beneficial Owners of this Trust or that represent Companies, Trusts
            or Other Entities that are Beneficial Owners of this Trust.
          </Typography>

          <Grid container columnSpacing={1.5} rowSpacing={0.5}>
            <BOIndividualsList />
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default TrustAdditionalDetailsIndividuals;
